import { render, staticRenderFns } from "./ConfirmPolicyImportModal.vue?vue&type=template&id=4b398237"
import script from "./ConfirmPolicyImportModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmPolicyImportModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPolicyImportModal.vue?vue&type=style&index=0&id=4b398237&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports